var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isAndroid() && !_vm.isElectron() && (!_vm.isHardwareServiceRunning || _vm.updatingHardware))?_c('div',{staticClass:"network-status",class:{ 'updating': _vm.updatingHardware }},[_vm._v(" "+_vm._s(_vm.statusMessage)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }